export const INDUSTRIES = [
  'Agriculture',
  'Construction',
  'Education',
  'Energy & Utilities',
  'Finance & Insurance',
  'Government',
  'Healthcare',
  'Hospitality',
  'Information Technology',
  'Legal',
  'Manufacturing',
  'Media & Entertainment',
  'Nonprofit',
  'Real Estate',
  'Retail',
  'Telecommunications',
  'Transportation & Logistics',
  'Other',
] as const;

export type Industry = (typeof INDUSTRIES)[number];
